if (process.env.NEXT_PUBLIC_API_MOCKING === 'enabled') {
    if (typeof window === 'undefined') {
        import('./server').then(({ server }) => {
            console.log('Starting server-side mock service worker…')
            server.listen({ onUnhandledRequest: 'bypass' })
        })
    } else {
        import('./browser').then(({ worker }) => {
            console.log('Starting client-side mock service worker…')
            worker.start({ onUnhandledRequest: 'bypass' }).catch(console.error)
        })
    }
}

export {}
